export default __webpack_public_path__ + "static/illustration-global.url-b857eee02a4af9e722ef3f09b05f1685.svg";